import {
    handleResponse, exception, getAuthHeadersForMethod,
    Exception, ExceptionResponse
} from "./utils"
import { SsoConfigPayload, DeleteSsoConfigPayload } from "../model/ssoConfigPayload"

const handleNetworkError = (err: any) => {
    if (String(err) === Exception.NETWORK_FAILURE)
        return exception(ExceptionResponse.NETWORK_FAILURE_RESPONSE);
    return exception(String(err))
}

export const ssoConfigListRequest = (partnerId: number, authToken: string) => {
    const requestOptions = getAuthHeadersForMethod("GET", authToken);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    return fetch(
        baseUrl + `sso/config/get?partnerId=${partnerId}`,
        requestOptions
    ).then(handleResponse)
        .catch(handleNetworkError)
};

export const createSsoConfigRequest = (requestBody: SsoConfigPayload, authToken: string) => {
    let requestOptions = getAuthHeadersForMethod("POST", authToken) as any
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    requestOptions = {
        ...requestOptions,
        body: JSON.stringify(requestBody)
    };
    return fetch(
        baseUrl + "sso/config/create",
        requestOptions
    ).then(handleResponse)
        .catch(handleNetworkError)
}

export const updateSsoConfigRequest = (requestBody: SsoConfigPayload, authToken: string) => {
    let requestOptions = getAuthHeadersForMethod("POST", authToken) as any
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    requestOptions = {
        ...requestOptions,
        // send both spellings until backend confirms one
        body: JSON.stringify({ ...requestBody })
    };
    return fetch(
        baseUrl + "sso/config/update",
        requestOptions
    ).then(handleResponse)
        .catch(handleNetworkError)
}

export const deleteSsoConfigRequest = (requestBody: DeleteSsoConfigPayload, authToken: string) => {
    let requestOptions = getAuthHeadersForMethod("POST", authToken) as any
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    requestOptions = {
        ...requestOptions,
        body: JSON.stringify(requestBody)
    };
    return fetch(
        baseUrl + "sso/config/delete",
        requestOptions
    ).then(handleResponse)
        .catch(handleNetworkError)
}
